package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.UpcomingW500Rounded: ImageVector
    get() {
        if (_upcomingW500Rounded != null) {
            return _upcomingW500Rounded!!
        }
        _upcomingW500Rounded = Builder(name = "UpcomingW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(162.87f, 856.02f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                lineTo(71.87f, 571.0f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadTo(162.87f, 480.0f)
                horizontalLineToRelative(162.17f)
                quadToRelative(15.39f, 0.0f, 26.68f, 10.12f)
                quadToRelative(11.28f, 10.12f, 13.52f, 24.84f)
                quadToRelative(6.67f, 34.71f, 40.96f, 59.88f)
                quadTo(440.48f, 600.0f, 480.0f, 600.0f)
                quadToRelative(39.52f, 0.0f, 73.8f, -25.16f)
                quadToRelative(34.29f, -25.17f, 40.96f, -59.88f)
                quadToRelative(2.24f, -14.72f, 13.52f, -24.84f)
                quadTo(619.57f, 480.0f, 634.96f, 480.0f)
                horizontalLineToRelative(162.17f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                reflectiveQuadTo(888.13f, 571.0f)
                verticalLineToRelative(194.02f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(162.87f, 856.02f)
                close()
                moveTo(162.87f, 765.02f)
                horizontalLineToRelative(634.26f)
                lineTo(797.13f, 571.0f)
                lineTo(669.98f, 571.0f)
                quadToRelative(-27.39f, 55.72f, -78.03f, 87.86f)
                quadTo(541.32f, 691.0f, 479.94f, 691.0f)
                quadToRelative(-61.37f, 0.0f, -111.95f, -32.26f)
                quadToRelative(-50.58f, -32.26f, -77.97f, -87.74f)
                lineTo(162.87f, 571.0f)
                verticalLineToRelative(194.02f)
                close()
                moveTo(675.76f, 396.83f)
                quadToRelative(-12.67f, -12.68f, -12.67f, -31.83f)
                reflectiveQuadToRelative(12.67f, -31.83f)
                lineToRelative(86.0f, -86.0f)
                quadToRelative(12.67f, -12.67f, 31.83f, -12.67f)
                quadToRelative(19.15f, 0.0f, 31.94f, 12.67f)
                quadToRelative(12.8f, 12.68f, 12.8f, 31.71f)
                reflectiveQuadToRelative(-12.92f, 31.95f)
                lineToRelative(-86.0f, 86.0f)
                quadToRelative(-12.67f, 12.67f, -31.82f, 12.67f)
                quadToRelative(-19.16f, 0.0f, -31.83f, -12.67f)
                close()
                moveTo(284.24f, 396.83f)
                quadToRelative(-12.67f, 12.67f, -31.83f, 12.67f)
                quadToRelative(-19.15f, 0.0f, -31.82f, -12.67f)
                lineToRelative(-86.0f, -86.0f)
                quadToRelative(-12.92f, -12.68f, -12.92f, -31.83f)
                reflectiveQuadToRelative(12.8f, -31.83f)
                quadToRelative(12.79f, -12.67f, 31.94f, -12.67f)
                quadToRelative(19.16f, 0.0f, 31.83f, 12.67f)
                lineToRelative(86.0f, 86.0f)
                quadToRelative(12.67f, 12.68f, 12.67f, 31.83f)
                reflectiveQuadToRelative(-12.67f, 31.83f)
                close()
                moveTo(447.67f, 301.33f)
                quadTo(434.5f, 288.15f, 434.5f, 269.0f)
                verticalLineToRelative(-120.0f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.33f)
                quadTo(460.85f, 103.5f, 480.0f, 103.5f)
                reflectiveQuadToRelative(32.33f, 13.17f)
                quadTo(525.5f, 129.85f, 525.5f, 149.0f)
                verticalLineToRelative(120.0f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.33f)
                quadTo(499.15f, 314.5f, 480.0f, 314.5f)
                reflectiveQuadToRelative(-32.33f, -13.17f)
                close()
                moveTo(162.87f, 765.02f)
                horizontalLineToRelative(634.26f)
                horizontalLineToRelative(-634.26f)
                close()
            }
        }
        .build()
        return _upcomingW500Rounded!!
    }

private var _upcomingW500Rounded: ImageVector? = null
